
                import "css-modules://src_components_footer"
                export default {"Main":"_5b8182","Inner":"_9642f9","Copyright":"_1a44ef","Links":"_c33248","Link":"_eafb10"}
            